// import Swiper, { Navigation } from 'swiper';

VIV.behaviours.slideBlock = (function (){

    const attach = function (context) {

        const blocks = context.querySelectorAll('.slideBlock');

        if (blocks.length === 0) {
            return;
        }

        // Async load swiper library and init slideshow when loaded
        import(/* webpackChunkName: "slider" */ "swiper").then(module => {
            initSlideshow(blocks, module);
        });

        // initSlideshow(blocks);
    };

    const initSlideshow = function (blocks, module) {

        const Swiper = module.default;
        const navClass = 'slideNavigation__item';

        blocks.forEach(block => {
            const breakpoints = JSON.parse(block.getAttribute('data-breakpoints'));
            const slider = block.querySelector('.slideBlock__slider');
            const buttonNext = block.querySelector(`.${navClass}--next`);
            const buttonPrev = block.querySelector(`.${navClass}--prev`);

            const swiper = new Swiper(slider, {
                modules: [ module.Navigation, module.Keyboard ],
                wrapperClass: 'slideBlock__items',
                slideClass: 'slideBlock__item',
                speed: 400,
                spaceBetween: 32,
                breakpoints: breakpoints,
                keyboard: {
                    enabled: false,
                    pageUpDown: false,
                },
                navigation: {
                    nextEl: buttonNext,
                    prevEl: buttonPrev,
                    disabledClass: `${navClass}--disabled`,
                    hiddenClass: `${navClass}--hidden`,
                    lockClass: `${navClass}--lock`,
                },
            });
        });
    };

    return {
        attach: attach
    }
})();
